import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Tag} from '../types';

export const EditPageNavigation = ({component}: { component: Tag }) => {

    const breadcrumbs = [{
        title: 'Account Settings',
        href: '/account-settings',
    },
        {
            title: 'Tag',
            href: `/tags`,
        },
        {title: component.name}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
